import React, { useImperativeHandle, useRef, useEffect, useState } from 'react';
import { Form } from 'antd';
import {
  getProjectSectionColumns,
  getDefaultRowData,
  // addModuleConfig,
} from '@modules/systemSetting/systemModule/systemModuleColumns';
import { DragableTableFrom as ManageSectionForm } from '@components';
import ManageMForm from '../projectsForm/customizeModule/manageMForm';
import MultiSectionForm from './components/multiSectionForm';

const Module = ({
  cRef,
  moduleFormData,
  tabKey,
  columns,
  defaultColumns,
  hideHomeSections,
  pendoField,
  sectionAddModuleConfig,
  addModuleConfig,
  formChange,
  ...props
}) => {
  const [moduleForm] = Form.useForm();
  const [sectionForm] = Form.useForm();
  const [refreshCount, setRefreshCount] = useState(0);
  const cumulateCount = () => {
    setRefreshCount((c) => c + 1);
    formChange();
  };

  useImperativeHandle(cRef, () => ({
    getModuleForm: () => moduleForm,
    getSectionForm: () => sectionForm,
  }));

  useEffect(() => {
    moduleForm.resetFields();
    sectionForm.resetFields();
    moduleForm.setFieldsValue(moduleFormData);
    sectionForm.setFieldsValue({
      projectHomeTmplt: moduleFormData?.projectHomeTmplt || [],
    });
  }, [moduleFormData]);

  const fieldMethods = useRef({});

  const registerFieldsMethods = (methods) => {
    fieldMethods.current = methods;
  };

  const handleSortEnd = ({ newIndex, oldIndex }) => {
    const { move } = fieldMethods.current;

    if (move) {
      move(oldIndex, newIndex);
    }
  };

  const sectionFormInProjHome = hideHomeSections ? null : (
    <div className="extra-form-in-project-home">
      <Form
        form={sectionForm}
        // {...formLayout}
        className="integration-manage-form"
        onValuesChange={cumulateCount}
        scrollToFirstError
        autoComplete="off"
        refreshCount={refreshCount}
        initialValues={{
          projectHomeTmplt: moduleFormData?.projectHomeTmplt || [],
        }}
      >
        <ManageSectionForm
          columns={getProjectSectionColumns(false, true)}
          registerFieldsMethods={registerFieldsMethods}
          onSortEnd={handleSortEnd}
          isLoading={false}
          formInstance={sectionForm}
          defaultColumns={getProjectSectionColumns(true, true)}
          name="projectHomeTmplt"
          isActive={true}
          getDefaultRowData={getDefaultRowData}
          addBtnText="Add New Section"
          configs={{ addModuleConfig: sectionAddModuleConfig }}
          ratioNeedFullSize={false}
          showSpn
          formChange={formChange}
        />
      </Form>
    </div>
  );

  const sectionFormInMultiSection = hideHomeSections
    ? null
    : ({ fieldKey, name }) => (
        <div className="extra-form-in-project-home">
          <Form.Item
            name={[`${fieldKey}internalPermissions`]}
            onValuesChange={cumulateCount}
          >
            {/* {console.log('吴迪debug：', moduleFormData, fieldKey, moduleFormData.customizeModule[fieldKey]?.multiSectionList)} */}
            <MultiSectionForm
              defaultValue={
                moduleFormData.customizeModule[fieldKey]?.multiSectionList?.map(
                  (item) => ({ ...item, section: item.titleName }),
                ) || []
              }
              formChange={formChange}
              onChange={(v) => {
                // 这里拿到的 moduleFormData 是未更新的，不要用他
                // 排序之后 filedKey没有更新， 也不要用他，用name（name这里也是和index一样的）
                console.log('form on change v', v);
                // console.log('form on change moduleFormData', moduleFormData);
                // console.log('form on change fieldKey', fieldKey);
                // console.log('form on change name', name);
                console.log(
                  'form on change moduleForm.getFieldsValue()',
                  moduleForm.getFieldsValue(),
                );
                if (Array.isArray(v)) {
                  const customizeModuleArr = moduleForm
                    ?.getFieldsValue()
                    ?.customizeModule?.map?.((item, index) => {
                      // console.log('item: ', item);
                      // 这里接不到id，否则应该用id去匹配
                      if (index === name) {
                        return {
                          ...item,
                          multiSectionList: v,
                        };
                      }
                      return item;
                    });
                  const resValue = {
                    ...moduleFormData,
                    customizeModule: customizeModuleArr,
                  };
                  // console.log('有v，resValue: ', resValue);
                  moduleForm.setFieldsValue(resValue);
                } else {
                  // 这里是处理link之类的【上传pdf、img】
                  // console.log('无v触发: ', {
                  //   ...moduleFormData,
                  //   customizeModule: moduleForm.getFieldsValue()?.customizeModule || [],
                  // });
                  moduleForm.setFieldsValue({
                    ...moduleFormData,
                    customizeModule:
                      moduleForm.getFieldsValue()?.customizeModule || [],
                  });
                }
                formChange();
              }}
            />
          </Form.Item>
        </div>
      );

  return (
    <ManageMForm
      form={moduleForm}
      tabKey={tabKey}
      columns={columns}
      defaultColumns={defaultColumns}
      showSpn
      projHomeExtraForm={sectionFormInProjHome}
      multiSectionExtraForm={sectionFormInMultiSection}
      pendoField={pendoField}
      ratioNeedFullSize={props.ratioNeedFullSize}
      configs={{ addModuleConfig }}
      formChange={formChange}
    />
  );
};

export default Module;
